export const useContributorUrl = (
  slug: string | undefined,
  absoluteUrl = false,
) => {
  return `${
    absoluteUrl ? 'https://www.mettle.co.uk' : ''
  }/contributors/${slug}/`
}
